import React, { useState } from 'react'
import { DropdownComponent, InputComponent } from '../../../components/core/Forms';
import {useReportStore} from '../../../state/useReportStore';
import { Button, SearchInput } from '../../../components/common';
import { CloseIcon } from '../../../assets/icons';
import { useInvoiceSearch } from '../../../hooks';
import { useCustomerSearch } from '../../../hooks';
import { useInventorySearch } from '../../../hooks';
import useDownloadReport from '../../../hooks/useDownloadReport';

interface InvoiceFilterProps{
   handleOnChange: (e: any) => void;
   formData: any
}

const InvoiceReportFilterForm = ( {handleOnChange, formData}: InvoiceFilterProps ) => {
    const [text, setText] = React.useState('')
    const generateReport = useReportStore( (state) => state.generateReport) 
    const [statusValue, setStatusValue] = useState("Select Status")
    const [typeValue, setTypeValue] = useState("Select Type")

    const { data: customers, isSearching, handleSearch: handleCustomerSearch } = useCustomerSearch()
    const {data: inventory, isSearching:inventorySearch, handleSearch} = useInventorySearch()


  return ( 
    <div>
           <div className='flex flex-col relative'>
            <div className='flex flex-col md:flex-row justify-between gap-[16px] md:gap-[24px] pt-[20px] xl:pt-[33px]'>
            <div className=''>
              <label>Generate by Customer</label>
              <SearchInput
              placeholder={"Select a Customer"}
              displayKey={"invoice Number"}
              isLoading={isSearching}
              value={text}
              clearIcon={CloseIcon}
              data={customers.map((customer:any) => ({
                ...customer,
                display: customer.name
              }))}
               emptyMessage={'This Item is not found'}
               dropdownClassName="w-[280px] md:ml-[2.7em] lg:w-[200px] lg:ml-[7em] xl:w-[200px] xl:ml-[-6em]"
              dropdownStyle={{
                maxHeight: '800px',
                overflowY: 'auto',
              }}
              classNames="280:max-w-[200px]  350:min-w-[350px] md:min-w-full md:max-w-[276px] border border-gray-300 bg-white max-h-[48px] min-h-[48px] placeholder:text-[15.25px]  rounded p-2  focus:outline-none focus:shadow-outline appearance-none focus:ring-0 leading-normal"
            />
            </div>

            <div>
            <label>Generate By Inventory</label>
            <SearchInput
              placeholder={"Select InventoryID"}
              displayKey={"invoice Number"}
              isLoading={isSearching}
              value={text}
              clearIcon={CloseIcon}
              data={inventory.map((inv:any) => ({
                ...inv,
                display: inv.id
              }))}
               emptyMessage={'This Item is not found'}
               dropdownClassName="w-[280px] md:ml-[2.7em] lg:w-[200px] lg:ml-[7em] xl:w-[200px] xl:ml-[-6em]"
              dropdownStyle={{
                maxHeight: '800px',
                overflowY: 'auto',
              }}
              classNames="280:max-w-[200px]  350:min-w-[350px] md:min-w-full md:max-w-[276px] border border-gray-300 bg-white max-h-[48px] min-h-[48px] placeholder:text-[15.25px]  rounded p-2  focus:outline-none focus:shadow-outline appearance-none focus:ring-0 leading-normal"
            />
            </div>
            
         </div> 


         <div className='flex flex-col md:flex-row justify-between gap-[16px] md:gap-[24px] pt-[20px] xl:pt-[33px]'>
            <div>
              <label>Generate by Status</label>
              <DropdownComponent
                 options={[]}
                 value={statusValue}
                 selectedValue={statusValue}
                 setSelectedValue={setStatusValue}
                 dropdownClassName='280:max-w-[320px]  350:max-w-[350px] 360:ml-[0.2em] md:ml-0  md:max-w-[276px] cursor-pointer'
                 iconClassName='mr-[2em] sm:mr-[7em] md:mr-[1.5em]'
                 /> 
            </div>

            <div>
            <label>Generate By Type</label>
            <DropdownComponent
                 options={[]}
                 value={typeValue}
                 selectedValue={typeValue}
                 setSelectedValue={setTypeValue}
                 dropdownClassName='280:max-w-[320px]  350:max-w-[350px] 360:ml-[0.2em] md:ml-0  md:max-w-[276px] cursor-pointer'
                 iconClassName='mr-[2em] sm:mr-[7em] md:mr-[1.5em]'
                 /> 
            </div>
            
         </div> 
          </div>
    </div>
  )
}

export default InvoiceReportFilterForm